<template>
  <div>
    <el-dialog :visible.sync="open" title="Add well" width="6.5rem" :close-on-click-modal="false" @close="handleCancel">
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item
          label="AER UWI"
          prop="UWI"
          :rules="uwiRules"
        >
          <el-input v-model="form.UWI" placeholder="Please fill in" autocomplete="off" />
        </el-form-item>
        <el-form-item
          label="FromToIDIdentifier"
          prop="fromToIDIdentifier"
          :rules="fromToRules"
        >
          <el-input v-model="form.fromToIDIdentifier" placeholder="Please fill in" autocomplete="off" />
        </el-form-item>
        <el-form-item
          label="Contains assets"
          prop="type"
          :rules="typeRules"
        >
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="OIL" name="type" />
            <el-checkbox label="GAS" name="type" />
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button type="primary" :loading="btnloading" @click="handleSubmite">
          Submit
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkWellAvailable } from '@/api/well.js'
export default {
  data() {
    return {
      open: false,
      uwiRules: [
        { required: true, message: 'Please enter AER UWI', trigger: 'blur' }
      ],
      fromToRules: [
        { required: true, message: 'Please enter FromToIDIdentifier', trigger: 'blur' }
      ],
      typeRules: [
        { type: 'array', required: true, message: 'Please select Contains assets', trigger: 'change' }
      ],
      form: {
        fromToIDIdentifier: undefined,
        UWI: undefined,
        type: []
      },
      btnloading: false
    }
  },
  methods: {
    show() {
      this.open = true
    },
    handleCancel() {
      this.btnloading = false
      this.$refs.form.resetFields()
      this.open = false
    },
    handleSubmite() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const json = {
            fromToIDIdentifier: this.form.fromToIDIdentifier,
            UWI: this.form.UWI,
            type: this.form.type.length === 2 ? 'ALL' : this.form.type[0]
          }
          this.btnloading = true
          checkWellAvailable(json).then(res => {
            this.$message.success('Submitted successfully！')
            this.handleCancel()
            this.$router.push({
              path: '/wellManagement/addWell',
              query: json
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
